'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _isEmpty2 = require('lodash/isEmpty');

var _isEmpty3 = _interopRequireDefault(_isEmpty2);

var _omit2 = require('lodash/omit');

var _omit3 = _interopRequireDefault(_omit2);

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _createConnector = require('../core/createConnector');

var _createConnector2 = _interopRequireDefault(_createConnector);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function getId(props) {
  return props.attributeName;
}

var namespace = 'toggle';

function getCurrentRefinement(props, searchState) {
  var id = getId(props);
  if (searchState[namespace] && searchState[namespace][id]) {
    return searchState[namespace][id];
  }
  if (props.defaultRefinement) {
    return props.defaultRefinement;
  }
  return false;
}

/**
 * connectToggle connector provides the logic to build a widget that will
 *  provides an on/off filtering feature based on an attribute value. Note that if you provide an “off” option, it will be refined at initialization.
 * @name connectToggle
 * @kind connector
 * @propType {string} attributeName - Name of the attribute on which to apply the `value` refinement. Required when `value` is present.
 * @propType {string} label - Label for this toggle.
 * @propType {string} function - Custom filter. Takes in a `SearchParameters` and returns a new `SearchParameters` with the filter applied.
 * @propType {string} value - Value of the refinement to apply on `attributeName`. Required when `attributeName` is present.
 * @propType {boolean} [defaultChecked=false] - Default searchState of the widget. Should the toggle be checked by default?
 * @providedPropType {function} refine - a function to toggle a refinement
 * @providedPropType {function} createURL - a function to generate a URL for the corresponding search state
 */

var _default = (0, _createConnector2.default)({
  displayName: 'AlgoliaToggle',

  propTypes: {
    label: _react.PropTypes.string,
    filter: _react.PropTypes.func,
    attributeName: _react.PropTypes.string,
    value: _react.PropTypes.any,
    defaultRefinement: _react.PropTypes.bool
  },

  getProvidedProps: function getProvidedProps(props, searchState) {
    var currentRefinement = getCurrentRefinement(props, searchState);
    return { currentRefinement: currentRefinement };
  },
  refine: function refine(props, searchState, nextChecked) {
    return _extends({}, searchState, _defineProperty({}, namespace, _extends({}, searchState[namespace], _defineProperty({}, getId(props, searchState), nextChecked))));
  },
  cleanUp: function cleanUp(props, searchState) {
    var cleanState = (0, _omit3.default)(searchState, namespace + '.' + getId(props));
    if ((0, _isEmpty3.default)(cleanState[namespace])) {
      return (0, _omit3.default)(cleanState, namespace);
    }
    return cleanState;
  },
  getSearchParameters: function getSearchParameters(searchParameters, props, searchState) {
    var attributeName = props.attributeName,
        value = props.value,
        filter = props.filter;

    var checked = getCurrentRefinement(props, searchState);

    if (checked) {
      if (attributeName) {
        searchParameters = searchParameters.addFacet(attributeName).addFacetRefinement(attributeName, value);
      }
      if (filter) {
        searchParameters = filter(searchParameters);
      }
    }

    return searchParameters;
  },
  getMetadata: function getMetadata(props, searchState) {
    var id = getId(props);
    var checked = getCurrentRefinement(props, searchState);
    var items = [];
    if (checked) {
      items.push({
        label: props.label,
        currentRefinement: props.label,
        attributeName: props.attributeName,
        value: function value(nextState) {
          return _extends({}, nextState, _defineProperty({}, namespace, _extends({}, nextState[namespace], _defineProperty({}, id, false))));
        }
      });
    }
    return { id: id, items: items };
  }
});

exports.default = _default;
;

var _temp = function () {
  if (typeof __REACT_HOT_LOADER__ === 'undefined') {
    return;
  }

  __REACT_HOT_LOADER__.register(getId, 'getId', 'src/connectors/connectToggle.js');

  __REACT_HOT_LOADER__.register(namespace, 'namespace', 'src/connectors/connectToggle.js');

  __REACT_HOT_LOADER__.register(getCurrentRefinement, 'getCurrentRefinement', 'src/connectors/connectToggle.js');

  __REACT_HOT_LOADER__.register(_default, 'default', 'src/connectors/connectToggle.js');
}();

;


//////////////////
// WEBPACK FOOTER
// /tmp/~/react-instantsearch/src/connectors/connectToggle.js
// module id = 527
// module chunks = 0